import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CustomerBiller } from '../models/model';
import { CustomerBillerStoreService } from '../services/customer-biller-store.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerBillerResolver implements Resolve<CustomerBiller> {
  constructor(private customerBillerStoreService: CustomerBillerStoreService) {
  }

  public resolve(route: ActivatedRouteSnapshot): Observable<CustomerBiller> {
    if (route.queryParams && route.queryParams.biller) {
      const id = route.queryParams.biller;
      return this.customerBillerStoreService.fetchCustomerBiller(id);
    } else {
      return of(null);
    }
  }
}
